import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigService } from 'src/app/config.service';
import { SettingsService } from 'src/app/shared/settings.service';
import * as fromSettings from 'src/app/shared/state/setting.reducer';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  connectionState = { class: 'text-danger', label: 'Verbinde zum Server...' };

  version = 'x.x.x';
  serverVersion = 'x.x.x';
  appState = 'App loading ...';
  loading = true;
  dev = environment.develop;

  private destroy$ = new Subject<void>();

  constructor(private settingsService: SettingsService,
    private configService: ConfigService, private store: Store<fromSettings.SettingsState>) { }

  ngOnInit() {
    this.store.select(fromSettings.getSettingsLoaded).pipe(
      takeUntil(this.destroy$)
    ).subscribe(loaded => {
      this.loading = !loaded;
      this.appState = loaded ? 'loading finished' : 'App loading ...';
    });

    this.version = this.configService.configData.appVersion;
    this.settingsService.getServerVersion().subscribe(
      version => {
        this.serverVersion = version.number;
        this.connectionState = { class: 'text-success', label: 'verbunden' };
      }
    );

    // this.sseService.connectionState$.subscribe((state) => {

    // switch (state) {
    //   case 'connected':
    //     this.connectionState = { class: 'text-success', label: 'verbunden' };
    //     break;
    //   case 'connecting':
    //     this.connectionState = { class: 'text-warning', label: 'Verbinde zum Server...' };
    //     break;
    //   case 'unavailable':
    //     this.connectionState = { class: 'text-danger', label: 'Server nicht erreichbar' };
    //     break;
    //   default:
    //     this.connectionState = { class: 'text-secondary', label: 'unbekannt' };
    // }
    // });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
